"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpProxy = void 0;
const operators_1 = require("rxjs/operators");
const helpers_1 = require("./helpers");
const types_1 = require("./types");
class HttpProxy {
    constructor(options) {
        this.params = {};
        this.method = options.method || types_1.METHOD.GET;
        this.url = options.url || '';
        this.isFileUpload = !!options.isFileUpload;
        this.responseType = options.responseType;
        this.skipAuthorization = options.skipAuthorization;
        this.mapper =
            typeof options.mapper === 'function' ? options.mapper : (data) => data;
    }
    load(payload, loadParams, loadFilterQuery) {
        const params = Object.assign(Object.assign({}, this.params), (loadParams || {}));
        const { request, method, url: baseUrl, isFileUpload, responseType, skipAuthorization } = this;
        if (!request) {
            throw new Error('HttpProxy error: before load must bee setted context via setContext');
        }
        const requestUrl = typeof baseUrl === 'function' ? baseUrl(params) : baseUrl;
        let url = requestUrl.replace(/{(\w+)}/g, (_, paramName) => {
            const value = params[paramName];
            if (!value && value !== 0) {
                // eslint-disable-next-line no-console
                console.warn(`HttpProxy error: param "${paramName}" must be defined`);
            }
            return String(value);
        });
        if (loadFilterQuery) {
            url = this.getUrlWithQuery(url, loadFilterQuery);
        }
        return request
            .execute(method, url, payload || null, {
            fileUpload: !!isFileUpload,
            responseType,
            skipAuthorization,
        })
            .pipe(operators_1.map((result) => {
            const resultData = result.data;
            let totalCount;
            if (helpers_1.isListResult(resultData)) {
                totalCount = resultData.pagination.total;
            }
            return {
                meta: {
                    status: result.meta.status,
                    totalCount,
                },
                data: this.mapper(result.data, params),
            };
        }));
    }
    setContext(request) {
        this.request = request;
    }
    setParams(params) {
        this.params = params;
    }
    getUrlWithQuery(url, filterQuery) {
        let resultUrl = url;
        resultUrl += this.getFilterQuery(resultUrl, filterQuery.filters);
        resultUrl += this.getSortQuery(resultUrl, filterQuery.sort);
        resultUrl += this.getPaginationQuery(resultUrl, filterQuery.skip, filterQuery.count);
        return resultUrl;
    }
    getFilterQuery(url, filterExpression) {
        if (!filterExpression) {
            return '';
        }
        const concatOperator = this.getConcatOperator(url);
        const query = Object.keys(filterExpression)
            .reduce((acc, key) => {
            const value = encodeURIComponent(filterExpression[key]);
            if (!value) {
                return acc;
            }
            acc.push(`${key}=${value}`);
            return acc;
        }, [])
            .join('&');
        return query.length ? `${concatOperator}${query}` : '';
    }
    getSortQuery(url, { orderColumn, orderAsc } = {}) {
        if (!orderColumn || typeof orderAsc !== 'boolean') {
            return '';
        }
        const concatOperator = this.getConcatOperator(url);
        return `${concatOperator}orderColumn=${orderColumn}&orderAsc=${orderAsc}`;
    }
    getPaginationQuery(url, skip, count) {
        if (typeof skip !== 'number' || typeof count !== 'number') {
            return '';
        }
        const concatOperator = this.getConcatOperator(url);
        const encodeSkip = encodeURIComponent(skip);
        const encodeCount = encodeURIComponent(count);
        return `${concatOperator}skip=${encodeSkip}&count=${encodeCount}`;
    }
    getConcatOperator(url) {
        return url.includes('?') ? '&' : '?';
    }
    isEmpty(data) {
        return data == null || data === '' || (Array.isArray(data) && !data.length);
    }
}
exports.HttpProxy = HttpProxy;
//# sourceMappingURL=HttpProxy.js.map